import React, { useEffect, useRef, useState } from "react";
import {
  StyleSheet,
  Text,
  View,
  TouchableOpacity,
  Dimensions,
  SafeAreaView,
  Image,
  ImageBackground,
  TextInput,
} from "react-native";
import Dawer from "../../component/drawer";
import Admin from "../../component/admin";
import { Octicons } from "@expo/vector-icons";
import { useIsFocused } from "@react-navigation/native";
import { useRecoilState } from "recoil";
import { tokenState } from "../../reducer/reducer/reducer/Atom";
import { apiservice, BaseUrlimage } from "../../service/service";
import moment from "moment";
const { width, height } = Dimensions.get("window");
export default function banner({ navigation }) {
  const focus = useIsFocused();
  const [token, setToken] = useRecoilState(tokenState);
  const [datadaily, setdatadaily] = useState({});
  const [datarun, setdatarun] = useState({});
  const [dataevent, setdataevent] = useState({});

  async function getuserin() {
    const response1 = await apiservice({
      path: "/banner/getbanner/pagedaily?role=admin",
      method: "get",
      token: token?.accessToken,
    });

    if (response1.status == 200) {
      setdatadaily(response1?.data?.data?.[0] || {});
    }
    const response2 = await apiservice({
      path: "/banner/getbanner/pagerun?role=admin",
      method: "get",
      token: token?.accessToken,
    });

    if (response2.status == 200) {
      setdatarun(response2.data.data?.[0] || {});
    }
    const response3 = await apiservice({
      path: "/banner/getbanner/pageevent?role=admin",
      method: "get",
      token: token?.accessToken,
    });
    if (response3.status == 200) {
      setdataevent(response3.data.data?.[0] || {});
    }
  }

  useEffect(() => {
    getuserin();
  }, [focus]);

  return (
    <View style={styles.container}>
      <Dawer navigation={navigation} />
      <View style={styles.back}>
        <Admin />
        <Text style={styles.textfree}>BANNER</Text>
        <View style={styles.viewfree}>
          <View style={styles.view}>
            <Image
              source={{
                uri:
                  BaseUrlimage + (datadaily?.img_list?.[0]),
              }}
              style={styles.img}
            />
            <View style={{ marginLeft: 30, width: "35%" }}>
              <Text style={styles.texthead}>หน้า DAILY BONUS</Text>
              <Text style={styles.textfic}>ขนาด 1000 * 450 </Text>
              <Text style={styles.textshow}>
                แสดงผลวันที่ {moment(datadaily?.startDate).format("DD")} -{" "}
                {moment(datadaily?.expireDate).format("DD/MM/YYYY")}
              </Text>
            </View>
            <TouchableOpacity
              onPress={() =>
                navigation.navigate("EditBanner", {
                  body: datadaily,
                  page: "pagedaily",
                })
              }
              style={styles.touchedit}
            >
              <Text style={[styles.texthead, { alignSelf: "center" }]}>
                EDIT
              </Text>
            </TouchableOpacity>
          </View>
          <View
            style={[
              styles.view,
              { borderColor: "#FCC81D" },
              { borderWidth: 0.5 },
            ]}
          >
            <Image
              source={{
                uri: BaseUrlimage + datarun?.img_list?.[0],
              }}
              style={styles.img}
            />
            <View style={{ marginLeft: 30, width: "35%" }}>
              <Text style={styles.texthead}>หน้า START RUN</Text>
              <Text style={styles.textfic}>ขนาด 1200 * 600</Text>
              <Text style={styles.textshow}>
                แสดงผลวันที่ {moment(datarun?.startDate).format("DD")} -{" "}
                {moment(datarun?.expireDate).format("DD/MM/YYYY")}
              </Text>
            </View>
            <TouchableOpacity
              onPress={() =>
                navigation.navigate("EditBanner", {
                  body: datarun,
                  page: "pagerun",
                })
              }
              style={styles.touchedit}
            >
              <Text style={[styles.texthead, { alignSelf: "center" }]}>
                EDIT
              </Text>
            </TouchableOpacity>
          </View>
        </View>

        <View style={styles.viewfree}>
          <View
            style={[
              styles.view,
              { borderColor: "#FCC81D" },
              { borderWidth: 0.5 },
            ]}
          >
            <Image
              source={{
                uri:
                  BaseUrlimage +
                  (dataevent?.img_list?.[0]),
              }}
              style={styles.img}
            />
            <View style={{ marginLeft: 30, width: "35%" }}>
              <Text style={styles.texthead}>หน้า EVENT</Text>
              <Text style={styles.textfic}>ขนาด 1200 * 600</Text>
              <Text style={styles.textshow}>
                {" "}
                แสดงผลวันที่ {moment(dataevent?.startDate).format("DD")} -{" "}
                {moment(dataevent?.expireDate).format("DD/MM/YYYY")}
              </Text>
            </View>
            <TouchableOpacity
              onPress={() =>
                navigation.navigate("EditBanner", {
                  body: dataevent,
                  page: "pageevent",
                })
              }
              style={styles.touchedit}
            >
              <Text style={[styles.texthead, { alignSelf: "center" }]}>
                EDIT
              </Text>
            </TouchableOpacity>
          </View>
        </View>
      </View>
    </View>
  );
}
const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: "#F3F3F3",
    flexDirection: "row",
  },
  back: {
    width: "85%",
    height: height,
    paddingHorizontal: "1%",
  },
  viewfree: {
    justifyContent: "space-between",
    width: "97%",
    flexDirection: "row",
    marginBottom: 30,
  },
  textfree: {
    fontFamily: "Prompt-Regular",
    fontSize: 25,
    color: "#000",
    fontWeight: "bold",
  },
  texthead: {
    fontFamily: "Prompt-Regular",
    fontSize: 20,
    color: "#000",
  },
  textfic: {
    fontFamily: "Prompt-Regular",
    fontSize: 18,
    color: "#ABABAB",
  },
  textshow: {
    fontFamily: "Prompt-Regular",
    fontSize: 14,
    color: "#000",
  },
  view: {
    width: "49%",
    height: 150,
    backgroundColor: "#fff",
    padding: 10,
    flexDirection: "row",
  },
  touchedit: {
    width: "15%",
    height: 33,
    backgroundColor: "#DBDBDB",
    borderRadius: 5,
    alignSelf: "flex-end",
  },
  img: {
    alignSelf: "center",
    width: "44%",
    height: 100,
  },
});
